import React from 'react';
import useFeatureToggleService from 'feature-toggle';
import BaseTasksPage from '../BaseTasksPage';
import useAdditionalWorkflowLaunchNavigator from './additionalWorkflowLaunchNavigator';
import AdditionalWorkflowSteps, { AdditionalWorkflowStepId } from './AdditionalWorkflowSteps';
import { useConflictsContext } from './AdditionalWorkflowLaunchWrapper';

export default function AdditionalWorkflowAllTasksPage() {
  const navigator = useAdditionalWorkflowLaunchNavigator();
  const conflictsContext = useConflictsContext();
  const featureToggleService = useFeatureToggleService();
  const isNewFlowEnabled = featureToggleService.isApplyAdditionalWorkflowEnabled();

  const handleNext = (isNewFlowEnabled && conflictsContext.hasConflicts)
    ? navigator.openConflictsPage
    : navigator.openPartiesPage;

  return (
    <BaseTasksPage
      roadmap={(
        <AdditionalWorkflowSteps
          currentStep={AdditionalWorkflowStepId.ALL_TASKS}
          hasConflicts={conflictsContext.hasConflicts}
        />
      )}
      onPrevClicked={navigator.openKeyDateTasksPage}
      onNextClicked={handleNext}
    />
  );
}
